import { Grid, Typography } from '@mui/material'
import React, { useState, useEffect } from 'react'
import useStyles from './useStyles'
import { DeprecateVersion } from '../../../components/Modals/FeatureFlags/DeprecateVersion'
import { useDispatch } from 'react-redux'
import { getAppVersionRTEnviroments } from '../../../app/services/versionEnviroments/getAppVersionRTEnviroments'
import { setErrorTextSnackBar, setRequestTextSnackBar } from '../../../redux/actions/app'
import { featureFlagsAppCodes } from '../../../utils/traducTypes'

export const VersionList = ({ plataform, addVersions }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [versions, setversions] = useState([])

  const getVersionsByPlataform = async () => {
    try {
      const version = await getAppVersionRTEnviroments(featureFlagsAppCodes[0], plataform.value)
      if (!version || !version?.data?.data?.activeVersions) return
      version.data.data.activeVersions.length > 0 &&
      addVersions(plataform.value, version.data.data.activeVersions)
      setversions(version.data.data.activeVersions)
    } catch (error) {
      dispatch(setRequestTextSnackBar())
      dispatch(
        setErrorTextSnackBar('Ocurrió un error al obtener las versiones')
      )
    }
  }
  useEffect(() => {
    getVersionsByPlataform()
  }, [])

  return (
    <Grid container className={classes.boxDetails}>
      <Grid
        item
        xs={12}
        style={{
          display: ' flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Typography
          style={{
            fontSize: 20,
            fontWeight: 'bold',
            color: '#4B4952',
            paddingLeft: 10,
            borderBottom: '1px solid rgba(36, 55, 143, 0.2)'
          }}
        >
          {plataform.title}
        </Typography>
      </Grid>
      {versions &&
        versions.map((item) => (
          <Grid key={item.appVersionCode} container style={{ padding: 10 }}>
            <Grid item xs={8}>
              <Typography
                style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  color: '#485450'
                }}
              >
                Versión {item.appVersionCode}
              </Typography>
              <div style={{ display: 'flex' }}>
                <Typography
                  style={{
                    fontSize: 13,
                    fontWeight: 'bold',
                    color: '#6e7a76'
                  }}
                >
                  Fecha de publicación: {item.releaseDate}
                </Typography>
              </div>
            </Grid>
            <Grid
              item
              xs={4}
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center'
              }}
            >
              <DeprecateVersion version={item} plataform={plataform} />
            </Grid>
          </Grid>
        ))}
    </Grid>
  )
}
